import React from 'react';
import { Box, Typography } from '@mui/material';

interface IDocumentSectionProps {
  title: string;
  children: React.ReactNode;
}

const DocumentSection = ({ title, children }: IDocumentSectionProps) => {
  return (
    <Box className="documentSection">
      <Typography variant="h6" className="documentSectionTitle">
        {title}
      </Typography>
      <Box className="documentSectionItems">
        {children}
      </Box>
    </Box>
  );
};

export default DocumentSection;